import { Box, Typography, Button, Container } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import LanguageDropdown from '@components/LanguageDropdown';
import { useState } from 'react';

const InstagramDataDeletionPage: React.FC = () => {
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();
  const [currentLanguage, setCurrentLanguage] = useState<string>(i18n.language);

  const handleLanguageChange = (language: string) => {
    setCurrentLanguage(language);
    i18n.changeLanguage(language);
  };

  return (
    <Box sx={{ width: '100%', minHeight: '100vh' }}>
      <LanguageDropdown currentLanguage={currentLanguage} changeLanguage={handleLanguageChange} />
      <Container maxWidth="md">
        <Box sx={{ py: 8, textAlign: 'center' }}>
          <Typography variant="h4" gutterBottom>
            {t('instagramDataDeletion.title')}
          </Typography>

          <Typography variant="body1" paragraph sx={{ mb: 4 }}>
            {t('instagramDataDeletion.description')}
          </Typography>

          <Typography
            variant="body1"
            paragraph
            sx={{
              mb: 4,
              whiteSpace: 'pre-line',
              textAlign: 'left',
              maxWidth: '600px',
              mx: 'auto'
            }}
          >
            {t('instagramDataDeletion.instructions')}
          </Typography>

          <Button
            variant="contained"
            color="primary"
            onClick={() => navigate('/showcase-management')}
            sx={{ mt: 2 }}
          >
            {t('instagramDataDeletion.goToShowcaseManagement')}
          </Button>
        </Box>
      </Container>
    </Box>
  );
};

export default InstagramDataDeletionPage;
